export const config = {
  coin: {
    alpha: {
      start: 1,
      end: 1,

    },
    scale: {
      start: 0.3,
      end: 0.6,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 900,
      end: 400,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 700,
    },
    maxSpeed: 0,
    startRotation: {
      min: -60,
      max: -120,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 10,
    },
    lifetime: {
      min: 5,
      max: 10,
    },
    blendMode: 'normal',
    frequency: 0.016,
    emitterLifetime: -1,
    maxParticles: 300,
    spawnType: 'circle',
    pos: {
      x: 0,
      y: 0,
    },
    spawnCircle: {
      x: 0,
      y: 0,
      r: 50,
    },
  },
}
